
import { GET_ANA_CARDS,
   GET_ANALYTICS_BAR,
   GET_ANALYTICS_PURPOSE,
    GET_ANALYTICS_ADDRESS } from "../action/constant";

const initialState = {
  cards:{},
  doughnut:{},
  pie:{},
  radar:{},
  polar:{},
  line:{},
  bar:{},
  loading:false,
  err:{},
}

export default function analyticsReducer(state=initialState,action){
  switch (action.type) {
    case GET_ANA_CARDS.PENDING:
      return {
        ...state,
         loading:true,
         err:{},
      }
    case GET_ANA_CARDS.SUCCESS:
      return {
        ...state,
        loading:false,
        err:{},
        cards:action.data
      }
   case GET_ANA_CARDS.ERROR:
     return {
       ...state,
       loading:false,
       err:action.err
     }
   case GET_ANALYTICS_BAR.PENDING:
     return {
       ...state,
       loading:true,
       err:{}
     }
    case GET_ANALYTICS_BAR.SUCCESS:
      return {
        ...state,
        loading:false,
        err:{},
        line:action.data.hours,
        bar:action.data.day,
      }
    case GET_ANALYTICS_BAR.ERROR:
      return {
        ...state,
        loading:false,
        err:action.err
      }
    case GET_ANALYTICS_PURPOSE.PENDING:
      return {
        ...state,
        loading:true,
        err:{},
      }
    case GET_ANALYTICS_PURPOSE.SUCCESS:
      return {
        ...state,
        loading:false,
        doughnut:action.data.purpose,
        radar:action.data.company,
        err:{},
      }
    case GET_ANALYTICS_PURPOSE.ERROR:
      return {
        ...state,
        loading:false,
        err:action.err,
      }
    case GET_ANALYTICS_ADDRESS.PENDING:
      return {
        ...state,
        loading:true,
        err:{},
      }
    case GET_ANALYTICS_ADDRESS.SUCCESS:
      return {
        ...state,
        loading:false,
        polar:action.data.name,
        pie:action.data.address,
        err:{},
      }
    case GET_ANALYTICS_ADDRESS.ERROR:
      return {
        ...state,
        loading:false,
        err:action.err
      }
    default:
      return state;
  }
}
